import { render, staticRenderFns } from "./NavigationItemEdit.vue?vue&type=template&id=682b8442&"
import script from "./NavigationItemEdit.vue?vue&type=script&lang=js&"
export * from "./NavigationItemEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports